import { render, staticRenderFns } from "./SpecialPriceDetails.vue?vue&type=template&id=5706f63d&"
import script from "./SpecialPriceDetails.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports